/**
 * Scroll-reveal: fade/slide elements in as they enter the viewport.
 * Opt in by adding the `reveal` class (handled gracefully if none exist).
 * Article photos and galleries opt in automatically, but only those that
 * start below the fold, so nothing already on screen blinks.
 */
export function initReveal() {
	document
		.querySelectorAll('.single-post .prose .wp-block-post-content > :is(.wp-block-image, .wp-block-gallery)')
		.forEach((el) => {
			if (el.getBoundingClientRect().top > window.innerHeight) el.classList.add('reveal');
		});

	const els = document.querySelectorAll('.reveal');
	if (!els.length) return;

	const io = new IntersectionObserver(
		(entries) => {
			entries.forEach((e) => {
				if (e.isIntersecting) {
					e.target.classList.add('in');
					io.unobserve(e.target);
				}
			});
		},
		{ threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
	);

	els.forEach((el, i) => {
		el.style.transitionDelay = `${(i % 4) * 0.06}s`;
		io.observe(el);
	});
}
